import { Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export function SidePanelHeader({ title = 'Details', subtitle, close, sx }) {
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          mr: -2.5,
          ...sx,
        }}
      >
        <Typography sx={{ flex: 1 }} variant="h6">
          {title}
        </Typography>
        <IconButton title="Close" onClick={close} sx={{ mr: 1 }}>
          <CloseIcon />
        </IconButton>
      </Box>
      {subtitle ? (
        <Typography variant="body2" sx={{ my: 1.5 }}>
          {subtitle}
        </Typography>
      ) : null}
    </Box>
  );
}
